// import { toUrlSearchParam } from "utils/common-util";

export const Routes = {
  SignIn: "/sign-in",
  LimitPage: "/limit-access",
  SSO: "/oauth",
  Terminated: "/terminated",
  Profile: "/profile",
  Error: "/error",
  Register: {
    CustomerInfo: "/register-customer-info",
    Suitability: "/register-suitability",
    RiskResult: "/register-riskResult",
    TermsConditions: "/register-termsConditions",
  },
  Disclaimer: "/disclaimer",
  History: {
    Histories: "/histories",
  },
  Primary: {
    Products: "/primary/primary-product",
    ProductDetail: "/primary/primary-product/:productRef",
    History: "/primary/history",
    ComplexProductDetail: "/primary/complex-product/:productRef",
    PortOverview: "/primary/port-overview",
  },
  Secondary: {
    Products: "/secondary/products",
    ProductDetail: "/secondary/product/:productRef",
    SecuritiesDetail: "/secondary/securities/:productRef",
    HistoryTax: "/history",
  },
  UltraHigh: {
    Base: "/ultra-high",
    Home: "/ultra-high/home",
    Lounge: "/ultra-high/lounge",
    BuySellSwitching: {
      Base: "/ultra-high/buy-sell-switching",
      Buy: "/ultra-high/buy-sell-switching/buy",
      Sell: "/ultra-high/buy-sell-switching/sell",
      Switch: "/ultra-high/buy-sell-switching/switch",
      Transaction: "/ultra-high/buy-sell-switching/transactions",
      TransactionDetail: "/ultra-high/buy-sell-switching/transactions/:transactionNo",
    },
    PrivateWealthManagement: {
      RegisterForm: "/ultra-high/private-wealth-management/register-form",
      RegisterDisclaimer1: "/ultra-high/private-wealth-management/disclaimer1",
      RegisterDisclaimer2: "/ultra-high/private-wealth-management/disclaimer2",
    },
    Portfolio: {
      Home: "/ultra-high/portfolio",
      Fund: "/ultra-high/portfolio/fund",
    },
    Investment: "/ultra-high/investment",
    Fund: {
      Home: "/ultra-high/fund",
      FundDetail: "/ultra-high/fund/:fundId",
    },
    Pdf: "/ultra-high/preview-pdf",
    ModelPortfolio: "/ultra-high/model-portfolio",
  },
  Restriction: "/restriction",
  Research: {
    ResearchList: "/research",
    ResearchDetail: "/research/:id",
  },
  SystemIsNotReady: "/temporarily-unavailable",
  KnowledgeAssessment: "/knowledge-assessment",
  StructureNote: "/structure-note",
  PerpetualBond: "/perpetual-bond",
  LombardLoan: "/lombard-loan",
  Custodian: "/custodian",
};

export function getRoutePath(path, ...params) {
  return path.replace(/:\w+/g, () => params.shift()).replace(/\/+/, "/");
}

export const routerChangeAction = "@@router/LOCATION_CHANGE";

export const LandingPage = {
  PWM: Routes.UltraHigh.Portfolio.Home,
  Retail: Routes.Primary.Products,
};

/** หน้าหลักตามประเภทผู้ใช้ (PB/PPB/PWM vs retail) — ใช้ร่วมกับ saga และ component */
export function getUserLandingPath(isPwmUser) {
  return isPwmUser ? LandingPage.PWM : LandingPage.Retail;
}
